<div class="card" [id]="challenge().offerId">
  <div
    class="card-header"
    role="img"
    [attr.aria-label]="config().header.backgroundImage.bannerAriaLabel"
    [title]="config().header.backgroundImage.bannerAriaLabel"
    [style]="{
      backgroundImage: config().header.backgroundImage.url | transformUrl,
    }"
  >
    @let title = config().header.backgroundImage.title;
    @if (title) {
      <p
        class="title"
        [style]="{
          color: title.color,
          fontFamily: title.fontFamily,
        }"
      >
        {{ title.text }}
      </p>
    }
  </div>

  <div
    class="card-subheader"
    [class.card-subheader-completed]="challenge().isCompleted"
    [style.backgroundColor]="
      challenge().isCompleted
        ? config().subHeader.completedBackgroundColor
        : config().subHeader.backgroundColor
    "
  >
    @let labelConfig = config().subHeader.title;
    @if (labelConfig) {
      <p
        class="label"
        [style]="{
          color: labelConfig.color,
          fontFamily: labelConfig.fontFamily,
        }"
      >
        {{
          labelConfig.label | replaceVars: challenge().minAmountByTransaction
        }}
      </p>
    }

    @if (challenge().canBeUnselected(phase())) {
      <b2c-unselection-button
        [phase]="phase()"
        [challenge]="challenge()"
        class="unselect-challenge"
        [isEventChallenge]="isEventChallenge()"
      />
    }
  </div>

  <div class="card-content" data-cy="frequency-card-content">
    @if (challenge().progress < challenge().target) {
      <div
        class="card-body"
        data-cy="frequency-card-content"
        [class.opacity-option]="!challenge().isSelected"
      >
        <img
          class="bag"
          [alt]="
            config().body.picture.alternativeText
              | replaceVars: challenge().rewardRatio
          "
          [src]="config().body.picture.imageUrl"
        />

        <div class="visits-summary">
          <div
            class="wording"
            [style]="{
              color: config().body.summary.color,
              fontFamily: config().body.summary.fontFamily,
            }"
          >
            <p class="win-text">{{ config().body.summary.text }}</p>
            <div class="target">{{ challenge().rewardRatio }}€</div>
          </div>
        </div>
      </div>

      <div class="visits-container">
        <span class="number" data-cy="progress">{{
          challenge().progress
        }}</span>
        <span class="sign">/</span>
        <span class="total" data-cy="target">{{ challenge().target }}</span>
        <span
          class="wording"
          [style]="{
            color: config().visitWording.color,
            fontFamily: config().visitWording.fontFamily,
          }"
        >
          {{ config().visitWording.text }}
        </span>
      </div>
    }
    <!-- Win Card -->
    @if (challenge().isCompleted) {
      <b2c-win-card class="win-container" [amount]="challenge().rewardRatio" />
    }

    <!-- Selection Button -->
    @if (!challenge().isSelected) {
      <div class="selection-section">
        <b2c-selection-button
          b2cElement
          [phase]="phase()"
          [challenge]="challenge()"
          [isBisCampaign]="isBisCampaign()"
          [isEventChallenge]="isEventChallenge()"
        />
      </div>
    }
  </div>
</div>
